import { defineMessages } from 'react-intl'

export default defineMessages({
  acs: {
    id: 'OrganizationSecurityPage.SamlConfiguration.Acs',
    defaultMessage: 'Assertion Consumer Service (ACS) URL'
  },
  adminLoginUrlDescription: {
    id: 'OrganizationSecurityPage.SamlConfiguration.AdminLoginURLDescription',
    defaultMessage:
      'Please bookmark this URL.  If you encounter issues with your SAML SSO configuration, this url can be used by organization administrators to access the Workgrid Console and correct the issue.'
  },
  adminLoginUrl: {
    id: 'OrganizationSecurityPage.SamlConfiguration.AdminLoginURL',
    defaultMessage: 'Admin Login URL'
  },
  adminLoginPath: {
    id: 'OrganizationSecurityPage.SamlConfiguration.AdminLoginPath',
    defaultMessage: `/console?adminLogin=true`
  },
  cardTitle: {
    id: 'OrganizationSecurityPage.SamlConfiguration.Title',
    defaultMessage: 'SAML Configuration'
  },
  companyCode: {
    id: 'OrganizationSecurityPage.SamlConfiguration.CompanyCode',
    defaultMessage: 'Company Code'
  },
  docsLink: {
    id: 'OrganizationSecurityPage.SamlConfiguration.DocsLink',
    defaultMessage: 'documentation'
  },
  description: {
    id: 'OrganizationSecurityPage.SamlConfiguration.Description',
    defaultMessage:
      'You will need some or all of these values to configure SAML.  Which values you will need depend on your Identity Provider (IDP). Refer to our {docsLink} for more information or reach out to Workgrid Support'
  },
  entityId: {
    id: 'OrganizationSecurityPage.SamlConfiguration.EntityId',
    defaultMessage: 'Entity Id (Identifier / Audience URI)'
  },
  poolId: {
    id: 'OrganizationSecurityPage.SamlConfiguration.PoolId',
    defaultMessage: 'Pool Id'
  }
})
